module.exports = __webpack_public_path__ + "5e5e59d9fb9dab68b178839d241a2cdc.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-116.cur
// module id = 438
// module chunks = 0